// packages/hooks/usePayments.ts

import { useData } from "../core/useData";
import { useToken } from "../auth/useToken";
import { useState } from "react";
import { QueryFilters } from "../../types/core/BaseService";
import { paymentService } from "../../services/paymentService";
import { Payment } from "../../types/Payment";

export function usePayments(initialFilters?: QueryFilters) {
    const { token } = useToken();
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(10); // Nombre d'éléments par p

    const {
        data: payments,
        loading,
        error,
        pages,
        total,
        count,
        refresh,
        deleteItem,
        updateItem,
        deleteManyItems
    } = useData<Payment>({
        ...paymentService,
        ...paymentService.baseService
    }, {
        ...initialFilters,
        page: currentPage,
        limit
    });




    const updatePaymentStatus = async (id: string, status: string) => {
        setLoadingStatus(true);
        if (!token) {
            throw new Error("Veillez vous connecter");
        }
        try {
            const result = await paymentService.updatePaymentStatus(id, status, token);
            await refresh();
            return result;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setLoadingStatus(false);
        }
    };


    
    // Fonction pour changer de page
    const goToPage = (page: number) => {
        if (page >= 1 && page <= pages) {
            setCurrentPage(page);
        }
    };

    // Fonction pour la page suivante
    const nextPage = () => {
        if (currentPage < pages) {
            setCurrentPage(currentPage + 1);
        }
    };

    // Fonction pour la page précédente
    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Rafraîchir les données en restant sur la page courante
    const refreshCurrentPage = () => {
        refresh();
    };
    return {
        payments,
        loading: loading || loadingStatus,
        error,
       total,
        pages,
        currentPage,
        limit,
        goToPage,
        nextPage,
        prevPage,
        count,
        refresh,
        refreshCurrentPage,
        deletePayment: deleteItem,
        updatePayment: updateItem,
        updatePaymentStatus,
        deleteManyPayments: deleteManyItems,

    };
}